<div class="p-3 bg-dark bg-opacity-25 rounded-3" style="border: 1px solid rgba(255,255,255,0.07);">
    <h5 class="fw-bold text-white mb-2 fs-6">Change Password</h5>
    <p class="text-muted small mb-3">Update your password to keep your account secure.</p>
    <form (ngSubmit)="onSubmit()">
        <!-- Current Password -->
        <div class="mb-3">
            <label for="oldPasswordInput" class="form-label text-muted small text-uppercase fw-bold mb-1" style="font-size: 0.75rem;">Current Password</label>
            <input type="password" id="oldPasswordInput" class="form-control form-control-sm py-2" 
                [ngModel]="currentPassword()" (ngModelChange)="currentPassword.set($event)" name="currentPassword" required>
        </div>

        <!-- New Password -->
        <div class="mb-3">
            <label for="newPasswordInput" class="form-label text-muted small text-uppercase fw-bold mb-1" style="font-size: 0.75rem;">New Password</label>
            <input type="password" id="newPasswordInput" class="form-control form-control-sm py-2" 
                [ngModel]="newPassword()" (ngModelChange)="newPassword.set($event)" name="newPassword" required>
        </div>

        <!-- Confirm Password -->
        <div class="mb-3">
            <label for="confirmPasswordInput" class="form-label text-muted small text-uppercase fw-bold mb-1" style="font-size: 0.75rem;">Confirm New Password</label>
            <input type="password" id="confirmPasswordInput" class="form-control form-control-sm py-2" 
                [ngModel]="confirmPassword()" (ngModelChange)="confirmPassword.set($event)" name="confirmPassword" required>
        </div>

        <!-- Buttons -->
        <div class="d-flex align-items-center gap-2 mt-3">
            <button type="button" class="btn btn-settings-cancel btn-sm px-3 py-1-5" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn btn-settings-danger btn-sm px-3 py-1-5 fw-bold">Save</button>
        </div>
    </form>
</div>
